import React from "react";
import "../pages/Sidebar.css"

const CountFollowing = () => {
  return (
    <div className="box">
      <h3>14</h3>
      <span>Following</span>
    </div>
  );
};

export default CountFollowing;
